module.exports = __webpack_public_path__ + "img/police_car_h.8c71ba41.png";